export default __webpack_public_path__ + "static/media/Del.fe71d612.jpg";